// Updated to use relative paths for proper nesting under /org/:orgId
const baseline = 'quality';

export const appRoutes = {
    HOME: `${baseline}/home`,
    TEAM: `${baseline}/team`,
    TICKET: `${baseline}/ticket`,
    SETTINGS: `${baseline}/settings`,
    SCORECARDS: `${baseline}/scorecards`,
    ANALYTICS: `${baseline}/analytics`,
    QUEUE: `${baseline}/queue`,
    CALIBRATION: `${baseline}/calibration`,
    CALIBRATIONS_HOME: `${baseline}/calibrations`,
    CALIBRATION_REVIEW: `${baseline}/calibration-review`,

    // Operator Legacy Routes
    OPERATOR_PROFILE: `${baseline}/profile`,
    OPERATOR_ADMIN: 'admin',
    OPERATOR_ADMIN_CONNECTIONS: 'admin/connections',
    OPERATOR_ADMIN_CONNECTIONS_ADD: 'admin/connections/add',
    OPERATOR_ADMIN_CONNECTIONS_SETTINGS: 'admin/connections/settings',
    OPERATOR_USERS: 'users',
    OPERATOR_USER_EDIT: 'user/:id/edit-user',

    // AUTHENTICATION ROUTES
    LOGIN: 'login',
    LOGGED_OUT: 'logged-out',
    INVITE: 'invite',
    INVITE_SIGN_UP: 'invite/signUp',
    AUTH_LOGIN: 'auth/login',
    AUTH_SETUP_BUILD: 'auth/setup/build',
    AUTH_SETUP_PROGRESS: 'auth/setup/progress',
    AUTH_SETUP_ONBOARDING: 'auth/setup/onboarding',
    AUTH_SETUP_CHECKING: 'auth/setup/checking',
    AUTH_SETUP_DONE: 'auth/setup/done',
    RESET_PASSWORD: 'reset-password',

    // Extension Helper Routes
    EXTENSION_SIGNIN: 'extension/signin',
};

export const ROUTES = appRoutes;